import axios, { AxiosInstance } from 'axios';

// export const request: AxiosInstance = axios.create({ baseURL: `https://${process.env.NODE_ENV == 'development' ? 'localhost:5050' : 'api.reeqzan.com'}/Slideshow` });
export const request: AxiosInstance = axios.create({ baseURL: `https://api.reeqzan.com/Slideshow` });
export const requestFixed: AxiosInstance = axios;